if (!customElements.get('lp-swiper-carousel')) {
  customElements.define(
    'lp-swiper-carousel',
    class LpSwiperCarousel extends HTMLElement {
      swiper = null;
      initTimeout = null;

      constructor() {
        super();
        this.onSectionLoad = this.onSectionLoad.bind(this);
        this.onSectionUnload = this.onSectionUnload.bind(this);
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.init();
        document.addEventListener('shopify:section:load', this.onSectionLoad);
        document.addEventListener('shopify:section:unload', this.onSectionUnload);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
        document.removeEventListener('shopify:section:unload', this.onSectionUnload);
        if (this.initTimeout) {
          clearTimeout(this.initTimeout);
          this.initTimeout = null;
        }
        this.destroySwiper();
      }

      onSectionLoad(event) {
        if (event?.detail?.sectionId !== this.sectionId) {
          return;
        }
        this.destroySwiper();
        this.init();
      }

      onSectionUnload(event) {
        if (event?.detail?.sectionId !== this.sectionId) {
          return;
        }
        this.destroySwiper();
      }

      init(attempt = 0) {
        if (this.initTimeout) {
          clearTimeout(this.initTimeout);
          this.initTimeout = null;
        }

        const swiperEl = this.querySelector('.lp-carousel__swiper') || this.querySelector('.swiper');
        if (!swiperEl) {
          return;
        }

        if (swiperEl.classList.contains('swiper-initialized')) {
          return;
        }

        if (typeof Swiper === 'undefined') {
          if (attempt < 30) {
            this.initTimeout = setTimeout(() => this.init(attempt + 1), attempt === 0 ? 0 : 100);
          }
          return;
        }

        const desktopSlides = parseFloat(this.dataset.desktop) || 4;
        const mobileSlides = parseFloat(this.dataset.mobile) || 1;
        const gap = parseFloat(this.dataset.gap) || 16;
        const showNavigationDesktop = this.dataset.showNavigationDesktop === 'true';
        const showNavigationMobile = this.dataset.showNavigationMobile === 'true';
        const showNavigation = showNavigationDesktop || showNavigationMobile;

        const config = {
          slidesPerView: mobileSlides,
          spaceBetween: gap,
          watchOverflow: true,
          grabCursor: true,
          speed: 600,
          breakpoints: {
            768: {
              slidesPerView: Math.min(2, desktopSlides),
              spaceBetween: gap,
            },
            1024: {
              slidesPerView: desktopSlides,
              spaceBetween: gap,
            },
          },
        };

        if (showNavigation) {
          const wrap = this.closest('.lp-carousel__slider-wrap');
          config.navigation = {
            nextEl: wrap ? wrap.querySelector('.lp-nav-btn--next') : null,
            prevEl: wrap ? wrap.querySelector('.lp-nav-btn--prev') : null,
          };
        }

        this.swiper = new Swiper(swiperEl, config);
      }

      destroySwiper() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }
    }
  );
}
